import { Controller } from "@hotwired/stimulus"

// Makes a table row clickable -> navigates to its url value (ignores clicks on links/buttons).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.element.addEventListener("click", this.go)
  }

  disconnect() {
    this.element.removeEventListener("click", this.go)
  }

  go = (e) => {
    if (e.target.closest("a, button, input, label")) return
    if (this.urlValue) Turbo.visit(this.urlValue)
  }
}
